<template>
    <div class="col-md subtotals">
        <div v-if="reloading"><div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
        <div v-if="!reloading">
            <div class="row">
                <div class="col-8">Subtotal</div>
                <div class="col-1">${{ formatCurrency(pricing.subtotal) }}</div>
            </div>

            <div class="row" v-for="fee in pricing.fees">
                <div class="col-8" :class="{ 'subtotal': fee.isSubtotal,  'text-success': fee.value < 0}">{{ fee.label }}</div>
                <div class="col-1">${{ formatCurrency(fee.value) }}</div>
            </div>

            <div class="line"></div>
            <div class="row total">
                <div class="col-8">TODAY'S TOTAL</div>
                <div class="col-1">${{ formatCurrency(pricing.total) }}</div>
            </div>
            <div class="row">
                <div class="col-10">
                    <small class="text-danger">$10 down pays your first week per item</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    export default {

        props: ['pricing', 'reloading'],

        methods: {
            formatCurrency(val) {
                return parseFloat(val).toFixed(2);
            }
        },

    }
</script>
